(function () {
  document.addEventListener("DOMContentLoaded", () => {
    console.log("Box Collection Init");
  });

  class BuildABox {
    constructor(options = {}) {
      this.initializeConfig(options);
      this.initializeDOMElements();
      this.initializeState();
      this.handleRedirect();
      this.initializeUI();
      this.attachEventListeners();
    }

    // Initialization Methods
    initializeConfig(options) {
      this.storageKey = options.storageKey || "buildABox";
      this.maxCapacity = options.maxCapacity || 6;
      this.slots = new Array(this.maxCapacity).fill(null);
    }

    initializeDOMElements() {
      this.boxContentEl = document.getElementById("box-content");
      this.productContainerEl = document.getElementById("products");
      this.sizeItemsContainer = document.querySelectorAll(".build-a-box__options__item") || [];
    }

    initializeState() {
      this.loadBox();
      this.checkForProductInURL();
    }

    handleRedirect() {
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      if (pathParts.length === 2) {
        const handle = this.getDefaultBoxHandle();
        if (handle) {
          const query = window.location.search;
          history.replaceState(null, "", `/collections/build-a-box/${handle}${query}`);
        }
      }
    }

    initializeUI() {
      this.initializeBoxOptionUI();
      this.updateUI();
    }

    attachEventListeners() {
      this.attachProductListeners();
      this.attachBoxSizeItemListeners();
      this.attachCartAndClearListeners();
      this.attachBackdropListener();

      const boxProductTitle = document.querySelector(".box-product-title");
      if (boxProductTitle) {
        boxProductTitle.addEventListener("click", () => this.toggleProductList());
      }
    }

    // UI Update Methods
    updateUI() {
      this.renderBoxContent();
      this.updateProductButtons();
      this.updateCartButtonState();
      this.updateClearButtonVisibility();
    }

    initializeBoxOptionUI() {
      const selectedOption = this.getSelectedBoxOption();
      if (selectedOption) {
        this.setBoxOption(selectedOption);
      }
    }

    checkForProductInURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const productHandle = urlParams.get("add_product");
    
      if (productHandle) {
        const productButton = Array.from(this.productContainerEl.querySelectorAll(".add-to-box")).find(
          (button) => button.getAttribute("data-product-handle") === productHandle
        );
    
        if (productButton) {
          const product = this.getProductFromButton(productButton);
          this.addProduct(product);
        } else {
          console.warn(`Product with handle "${productHandle}" not found.`);
        }
      }
    }

    renderBoxContent() {
      if (!this.boxContentEl) return;
      this.boxContentEl.innerHTML = "";
      this.slots.forEach((slot, index) => {
        const li = document.createElement("li");
        li.textContent = slot ? slot.name : "Empty";
        if (!slot) li.classList.add("muted");
        if (slot) {
          const removeBtn = document.createElement("button");
          removeBtn.textContent = "Remove";
          removeBtn.addEventListener("click", () => this.removeProduct(index));
          li.appendChild(removeBtn);
        }
        this.boxContentEl.appendChild(li);
      });
    }

    updateProductButtons() {
      if (!this.productContainerEl) return;
      const productCounts = this.getProductCounts();
      const buttons = this.productContainerEl.querySelectorAll(".add-to-box");
      buttons.forEach((button) => {
        const productId = button.getAttribute("data-id");
        const textSpan = button.querySelector("[data-add-to-box-text]");
        if (textSpan) {
          textSpan.textContent = productCounts[productId] ? "Add another" : "Add to box";
        }
      });
    }

    updateCartButtonState() {
      const cartButton = document.querySelector("[data-add-box-to-cart]");
      const cartButtonText = document.querySelector("[data-add-to-cart-text]")
      if (cartButton) cartButton.disabled = !this.isBoxFull();
      if (cartButtonText) cartButtonText.textContent = this.isBoxFull() ? 'Add to cart' : `Add ${this.getEmptySpaces()} more`;
    }

    updateClearButtonVisibility() {
      const clearButton = document.querySelector("[data-empty-box]");
      if (clearButton) clearButton.style.display = this.isBoxEmpty() ? "none" : "block";
    }

    // Event Handlers
    attachProductListeners() {
      const buttons = document.querySelectorAll(".add-to-box");
      buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          const product = this.getProductFromButton(button);
          this.addProduct(product);
        });
      });
    }

    attachBoxSizeItemListeners() {
      Array.from(this.sizeItemsContainer).forEach((item) => {
        item.addEventListener("click", () => this.setBoxOption(item));
      });
    }

    attachCartAndClearListeners() {
      const addBoxBtn = document.querySelector("[data-add-box-to-cart]");
      if (addBoxBtn) {
        addBoxBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.addBoxToCart();
        });
      }

      const emptyBoxBtn = document.querySelector("[data-empty-box]");
      if (emptyBoxBtn) {
        emptyBoxBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.emptyBox();
        });
      }
    }

    // Box Management Methods
    addProduct(product) {
      const emptyIndex = this.slots.findIndex((slot) => slot === null);
      if (emptyIndex === -1) {
        this.handleFullBox(product);
        return;
      }
      this.slots[emptyIndex] = product;
      this.saveBox();
      this.updateUI();
    }

    removeProduct(slotIndex) {
      if (slotIndex < 0 || slotIndex >= this.slots.length) return;
      this.slots[slotIndex] = null;
      this.saveBox();
      this.updateUI();
    }

    emptyBox() {
      this.slots = new Array(this.maxCapacity).fill(null);
      this.saveBox();
      this.updateUI();
    }

    setBoxOption(optionEl) {
      Array.from(this.sizeItemsContainer).forEach((item) => item.classList.remove("active"));
      optionEl.classList.add("active");
      this.updateBoxDetails(optionEl);
      this.updateBoxSize(parseInt(optionEl.getAttribute("data-size"), 10));
    }

    updateBoxSize(newSize) {
      this.slots = this.slots.slice(0, newSize).concat(new Array(Math.max(0, newSize - this.slots.length)).fill(null));
      this.maxCapacity = newSize;
      this.saveBox();
      this.updateUI();
    }

    addBoxToCart() {
      const cartButton = document.querySelector("[data-add-box-to-cart]");
      const activeOption = this.getActiveBoxOption();

      if (cartButton) this.setCartButtonLoadingState(cartButton, true);

      if (!this.validateBox(cartButton, activeOption)) return;

      const variantId = activeOption.getAttribute("data-variant-id");
      const productHandle = activeOption.getAttribute("data-product-handle");

      this.fetchProductDetails(productHandle)
        .then((product) => this.validateVariant(product, variantId))
        .then((variant) => this.addToCart(variant, cartButton))
        .catch((error) => this.handleAddToCartError(error, cartButton));
    }

    fetchProductDetails(productHandle) {
      return fetch(`/products/${productHandle}.js`).then((response) => {
        if (!response.ok) throw new Error("Unable to fetch product details.");
        return response.json();
      });
    }

    validateBox(cartButton, activeOption) {
      if (!this.slots.every((slot) => slot !== null)) {
        this.showDialog({
          title: "Incomplete Box",
          body: "Your box must be completely filled before adding to cart.",
        });
        this.setCartButtonLoadingState(cartButton, false);
        return false;
      }

      if (!activeOption) {
        this.showDialog({
          title: "No Box Size Selected",
          body: "Please select a box size.",
        });
        this.setCartButtonLoadingState(cartButton, false);
        return false;
      }

      return true;
    }

    validateVariant(product, variantId) {
      const variant = product.variants.find((v) => v.id == variantId);
      if (!variant) throw new Error("Variant not found in product data.");

      if (parseInt(variant.title, 10) !== this.slots.length) {
        this.showDialog({
          title: "Box Configuration Mismatch",
          body: "The box configuration does not match the selected variant.",
        });
        throw new Error("Box configuration mismatch.");
      }

      return variant;
    }

    addToCart(variant, cartButton) {
      const payload = {
        id: variant.id,
        quantity: 1,
        properties: {
          "Box Contents": this.slots.map((slot) => slot.name).join(", "),
        },
      };

      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Error adding box to cart.");
          return response.json();
        })
        .then((data) => {
          this.handleCartSuccess(cartButton);
        });
    }

    handleCartSuccess(cartButton) {
      document.dispatchEvent(
        new CustomEvent("theme:cart:added", {
          detail: { button: cartButton },
          bubbles: false,
        })
      );
      document.dispatchEvent(
        new CustomEvent("theme:cart:refresh", { bubbles: true })
      );

      this.setCartButtonLoadingState(cartButton, false);
      this.emptyBox();
    }

    setCartButtonLoadingState(button, isLoading) {
      button.disabled = isLoading;
      button.classList.toggle("loading", isLoading);
    }

    handleFullBox(product) {
      const availableOptions = Array.from(this.sizeItemsContainer)
        .filter(
          (item) =>
            parseInt(item.getAttribute("data-size"), 10) > this.maxCapacity
        )
        .sort(
          (a, b) =>
            parseInt(a.getAttribute("data-size"), 10) -
            parseInt(b.getAttribute("data-size"), 10)
        );

      if (availableOptions.length > 0) {
        this.showDialog({
          title: "Box is Full",
          body: "Would you like to upgrade your box?",
          buttons: [
            {
              text: "Upgrade Box",
              class: "btn btn--primary btn--small",
              callback: (modalEl) => {
                modalEl.close();
                this.setBoxOption(availableOptions[0]);
                this.addProduct(product);
              },
            },
            {
              text: "Keep Editing",
              class: "btn btn--secondary btn--small",
              callback: (modalEl) => modalEl.close(),
            },
          ],
        });
      } else {
        this.showDialog({
          title: "Box is Full",
          body: "Your box is full. Would you like to add this box to your cart and start a new one?",
          buttons: [
            {
              text: "Add to cart",
              class: "btn btn--primary btn--small",
              callback: (modalEl) => {
                modalEl.close();
                this.addBoxToCart();
              },
            },
            {
              text: "Keep Editing",
              class: "btn btn--secondary btn--small",
              callback: (modalEl) => modalEl.close(),
            },
          ],
        });
      }
    }

    handleAddToCartError(error, cartButton) {
      console.error("Error in addBoxToCart:", error);
      this.showDialog({
        title: "Error",
        body: "There was an error adding the box to your cart. Please try again.",
      });
      this.setCartButtonLoadingState(cartButton, false);
    }

    getActiveBoxOption() {
      return Array.from(this.sizeItemsContainer).find((item) =>
        item.classList.contains("active")
      );
    }

    // Helper Methods
    updateBoxDetails(optionEl) {
      const titleEl = document.getElementById("box-product-title");
      const descriptionEl = document.getElementById("box-product-description");
      const priceEl = document.getElementById("box-product-price");

      if (titleEl) titleEl.textContent = optionEl.getAttribute("data-title") || "";
      if (descriptionEl) descriptionEl.textContent = optionEl.getAttribute("data-description") || "";
      if (priceEl) priceEl.textContent = optionEl.getAttribute("data-price") || "";

      const newHandle = optionEl.getAttribute("data-handle");
      if (newHandle) {
        const basePath = "/collections/build-a-box";
        const query = window.location.search;
        history.pushState(null, "", `${basePath}/${newHandle}${query}`);
      }
    }

    getDefaultBoxHandle() {
      let handle = null;
      this.sizeItemsContainer.forEach((item) => {
        const itemSize = parseInt(item.getAttribute("data-size"), 10);
        if (itemSize === this.maxCapacity) {
          handle = item.getAttribute("data-handle");
        }
      });
      return handle;
    }

    getSelectedBoxOption() {
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const selectedHandle = pathParts.length >= 3 ? pathParts[2] : null;
      return Array.from(this.sizeItemsContainer).find(
        (item) => item.getAttribute("data-handle") === selectedHandle
      );
    }

    getProductCounts() {
      return this.slots.reduce((counts, slot) => {
        if (slot) counts[slot.id] = (counts[slot.id] || 0) + 1;
        return counts;
      }, {});
    }

    getProductFromButton(button) {
      return {
        id: button.getAttribute("data-id"),
        name: button.getAttribute("data-add-to-box"),
      };
    }

    isBoxFull() {
      return this.slots.every((slot) => slot !== null);
    }

    isBoxEmpty() {
      return this.slots.every((slot) => slot === null);
    }

    getEmptySpaces() {
      return this.slots.filter((slot) => slot === null).length;
    }

    saveBox() {
      localStorage.setItem(this.storageKey, JSON.stringify({ slots: this.slots, maxCapacity: this.maxCapacity }));
    }

    loadBox() {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const data = JSON.parse(stored);
        this.slots = data.slots;
        this.maxCapacity = data.maxCapacity;
      }
    }

    attachBackdropListener() {
      const backdrop = document.querySelector(".box-cart__backdrop");
      if (backdrop) {
        backdrop.addEventListener("click", () => this.closeProductList());
      }
    }

    openProductList() {
      const backdrop = document.querySelector(".box-cart__backdrop");
      const productList = document.querySelector(".product-list");

      if (backdrop) backdrop.classList.add("show");
      if (productList) productList.classList.add("open");
    }

    closeProductList() {
      const backdrop = document.querySelector(".box-cart__backdrop");
      const productList = document.querySelector(".product-list");

      if (backdrop) backdrop.classList.remove("show");
      if (productList) productList.classList.remove("open");
    }

    toggleProductList() {
      const backdrop = document.querySelector(".box-cart__backdrop");
      const productList = document.querySelector(".product-list");

      if (backdrop && productList) {
      const isOpen = productList.classList.contains("open");
      if (isOpen) {
        backdrop.classList.remove("show");
        productList.classList.remove("open");
      } else {
        backdrop.classList.add("show");
        productList.classList.add("open");
      }
      }
    }

    showDialog(details) {
      document.dispatchEvent(
        new CustomEvent("theme:dialog:open", {
          detail: {
            title: details.title || "Notice",
            body: details.body || "",
            buttons: details.buttons || [
              {
                text: "Close",
                class: "btn btn--secondary btn--small",
                callback: (modalEl) => modalEl.close(),
              },
            ],
          },
          bubbles: true,
        })
      );
    }
  }

  // Example instantiation
  new BuildABox({
    storageKey: "buildABox",
    maxCapacity: 12,
  });
})();
